import React, { useContext, useState } from 'react'
import DataContext from "../../../../../context/DataContext";
import { Button, Menu, MenuItem } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

const DocumentActions = ({document, handleOpenAssociateAppointmentModal, setIsLaunchedFromAppointmentsTab}) => {
    const { userRoles } = useContext(DataContext);
    const [anchorEl, setAnchorEl] = useState(null);

    const canViewAssociatedDocuments = userRoles.permissions.includes(
        "filemanager.view_document_association"
    );

    const handleClickActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleSelectAction = (action) => {
        handleCloseActionMenu();
        if (action === "associateDocuments") {
            setIsLaunchedFromAppointmentsTab(false);
            handleOpenAssociateAppointmentModal(document, true);

        }
    };

    if (!canViewAssociatedDocuments) {
        return null;
    }

    return (
        <div className="flex items-center mr-4">
            <Button
                className="text-sm capitalize"
                id="action-button"
                aria-controls={!!anchorEl ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={!!anchorEl || undefined}
                onClick={handleClickActionMenu}
                endIcon={<ArrowDropDown />}
            >
                Actions
            </Button>
            <Menu
                id="action-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={handleCloseActionMenu}
                MenuListProps={{
                    "aria-labelledby": "action-button",
                }}
            >
                <MenuItem
                    className="text-sm"
                    onClick={() => handleSelectAction("associateDocuments")}
                >
                    Associate Documents
                </MenuItem>
            </Menu>
        </div>
    )
}

export default DocumentActions